import React, { FormEvent, useEffect, useState } from 'react';

import { Button, MenuItem, Stack, TextField } from '@mui/material';

import { ChatAccountFilter } from '~/hooks/apis/trip-planner/useChatReviewList';

import { TripPlannerChatSearchParams } from '../useTripPlannerChatSearchParams';

type Props = {
  initialValues: TripPlannerChatSearchParams;
  onSearch: (values: TripPlannerChatSearchParams) => void;
  account: ChatAccountFilter;
  minMessages: number;
  onAccountChange: (value: string) => void;
  onMinMessagesChange: (value: string) => void;
};

export default function TripPlannerChatSearchForm({
  initialValues,
  onSearch,
  account,
  minMessages,
  onAccountChange,
  onMinMessagesChange,
}: Props) {
  const [chatId, setChatId] = useState(initialValues.chatId ?? '');
  const [userId, setUserId] = useState(initialValues.userId ?? '');

  useEffect(() => {
    setChatId(initialValues.chatId ?? '');
    setUserId(initialValues.userId ?? '');
  }, [initialValues.chatId, initialValues.userId]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    onSearch({
      chatId,
      userId,
    });
  };

  return (
    <Stack component="form" mb={0.5} onSubmit={handleSubmit}>
      <Stack spacing={1.5} direction={{ xs: 'column', md: 'row' }} flexWrap="wrap" alignItems={{ md: 'center' }}>
        <TextField
          label="Conversation ID"
          variant="outlined"
          value={chatId}
          sx={{ width: 180, flexShrink: 0 }}
          onChange={(event) => setChatId(event.target.value)}
        />
        <TextField
          label="User Id"
          variant="outlined"
          value={userId}
          sx={{ flex: 1, minWidth: 200 }}
          onChange={(event) => setUserId(event.target.value)}
        />
        <TextField
          select
          size="small"
          label="Account"
          value={account}
          onChange={(event) => onAccountChange(event.target.value)}
          sx={{ minWidth: 160 }}
        >
          <MenuItem value="all">All chats</MenuItem>
          <MenuItem value="registered">Logged in only</MenuItem>
          <MenuItem value="guest">Logged out only</MenuItem>
        </TextField>
        <TextField
          size="small"
          label="Min. msgs"
          type="number"
          value={minMessages}
          inputProps={{ min: 0, step: 1 }}
          InputLabelProps={{ shrink: true }}
          onChange={(event) => onMinMessagesChange(event.target.value)}
          sx={{ width: 180 }}
        />
        <Button type="submit" variant="contained" color="primary" sx={{ flexShrink: 0 }}>
          Search
        </Button>
      </Stack>
    </Stack>
  );
}
